import React from "react";
import { Box, Typography } from "@mui/material";
import { COLORS, CONTENT_MAX_WIDTH, FONT } from "../../shared/styles";
import { ROUTING_OPTIONS } from "./constants";
import TicketRoutingOptionCard from "./TicketRoutingOptionCard";

const sectionTitleSx = {
  color: COLORS.textPrimary,
  fontFamily: FONT.family,
  fontSize: "20px",
  fontWeight: 500,
  lineHeight: "34px",
  m: 0,
};

function TicketRoutingOptions({
  routingMode,
  onRoutingModeChange,
  teams,
  teamId,
  onTeamChange,
  teamsLoading,
}) {
  return (
    <Box sx={{ mt: "32px", width: "100%", maxWidth: CONTENT_MAX_WIDTH }}>
      <Typography component="h3" sx={sectionTitleSx}>
        Add-ons
      </Typography>
      <Box sx={{ mt: "16px", display: "flex", flexDirection: "column", gap: "8px" }}>
        {ROUTING_OPTIONS.map((option) => (
          <TicketRoutingOptionCard
            key={option.key}
            option={option}
            selected={routingMode === option.key}
            onSelect={() => onRoutingModeChange(option.key)}
            teams={teams}
            teamId={teamId}
            onTeamChange={onTeamChange}
            teamsLoading={teamsLoading}
          />
        ))}
      </Box>
    </Box>
  );
}

export default TicketRoutingOptions;
